import { Module, Lesson, AudioTrack, Book, Note, LessonType } from '../types';

export const modules: Module[] = [
  {
    title: "Intro til pust",
    slug: "intro-til-pust",
    summary: "Grunnleggende fysiologi + praksis for ro/fokus.",
    level: "Intro",
    is_premium: false,
    order: 1,
    tags: ["pust", "intro"]
  },
  {
    title: "Stressregulering",
    slug: "stressregulering",
    summary: "Teknikker for å håndtere akutt og kronisk stress.",
    level: "Intermediate",
    is_premium: true,
    order: 2,
    tags: ["stress", "ro"]
  },
  {
    title: "Søvnoptimalisering",
    slug: "sovnoptimalisering",
    summary: "Forbered kropp og sinn for dyp og restorativ søvn.",
    level: "Intermediate",
    is_premium: true,
    order: 3,
    tags: ["søvn", "avslapning"]
  }
];

export const lessons: Lesson[] = [
  {
    title: "Calm Focus (5m)",
    slug: "calm-focus-5m",
    module: "intro-til-pust",
    type: LessonType.Audio,
    media_url: "/audio/free/calm_focus_5m.mp3",
    duration_min: 5,
    summary: "Guidet fokuspust, myk start.",
    is_premium: false
  },
  {
    title: "Hva er pust?",
    slug: "hva-er-pust",
    module: "intro-til-pust",
    type: LessonType.Video,
    media_url: "https://player.vimeo.com/video/824804225", // Placeholder
    duration_min: 3,
    summary: "En kort introduksjon til pustens fysiologi.",
    is_premium: false
  },
   {
    title: "Kroppsholdning og Pust",
    slug: "kroppsholdning-pust",
    module: "intro-til-pust",
    type: LessonType.Video, // Using Video type, but will render custom component
    media_url: "",
    duration_min: 7,
    summary: "Forstå hvordan bekken-tilt og holdning påvirker pusten din.",
    is_premium: false,
  },
  {
    title: "Boks-pusting (4m)",
    slug: "boks-pusting-4m",
    module: "stressregulering",
    type: LessonType.Audio,
    media_url: "/audio/premium/box-breathing_4m.mp3",
    duration_min: 4,
    summary: "En klassisk teknikk for å roe nervesystemet.",
    is_premium: true
  },
  {
    title: "Søvn Pust (10m)",
    slug: "sovn-pust-10m",
    module: "sovnoptimalisering",
    type: LessonType.Audio,
    media_url: "/audio/premium/sleep-breath_10m.mp3",
    duration_min: 10,
    summary: "Rolig nedpusting designet for å forberede deg for søvn.",
    is_premium: true
  }
];

export const audioTracks: AudioTrack[] = [
  {
    title: "Calm Focus 5m",
    slug: "calm-focus-5m",
    audio_url: "/audio/free/calm_focus_5m.mp3",
    intention: "Focus",
    is_premium: false,
    duration_min: 5
  },
  {
    title: "Downshift 8m",
    slug: "downshift-8m",
    audio_url: "/audio/premium/downshift_8m.mp3",
    intention: "Sleep",
    is_premium: true,
    duration_min: 8
  },
  {
    title: "Energy Boost 3m",
    slug: "energy-boost-3m",
    audio_url: "/audio/premium/energy-boost_3m.mp3",
    intention: "Energy",
    is_premium: true,
    duration_min: 3
  },
  {
    title: "Midday Reset 6m",
    slug: "midday-reset-6m",
    audio_url: "/audio/premium/midday-reset_6m.mp3",
    intention: "Relax",
    is_premium: true,
    duration_min: 6
  }
];

export const books: Book[] = [
  {
    title: "Breath",
    author: "James Nestor",
    summary: "Nesepust, CO2-toleranse, rytme.",
    is_premium_notes: false
  },
  {
    title: "Why We Sleep",
    author: "Matthew Walker",
    summary: "Søvnens vitenskap og dens avgjørende rolle for helse.",
    is_premium_notes: true
  },
  {
    title: "Atomic Habits",
    author: "James Clear",
    summary: "Bygg gode vaner og bryt dårlige med små, enkle steg.",
    is_premium_notes: true
  }
];

export const initialNotes: Note[] = [
  {
    id: 'note1',
    user_id: "uid123",
    template: "refleksjon",
    content: "Kroppen føltes mer avslappet og tankene roligere etter økten.",
    timestamp: "2025-11-04T08:05:00Z",
    lesson_slug: 'calm-focus-5m'
  }
];